/**
 * メンテナンス予告の予定を、文言にマウスを乗せているあいだだけポップオーバー（Popover API）で表示する
 *
 * 予告の箱（[data-maintenance-notice]、resources/views/layouts/partials/maintenance-notice.blade.php）は、画面下部に固定された
 * 操作バーのボタンのクリックを遮らないよう pointer-events-none にしている（lms-797 T9-1）。そのため箱では mouseenter /
 * mouseleave が起きない。代わりに document の mousemove でマウスの座標が文言（[data-maintenance-schedule-trigger]。
 * 「メンテナンスまで残り〜」など）の矩形の中にあるかを判定し、予定（[data-maintenance-schedule]、popover="manual"）を
 * 開け閉めする。箱の中でも、文言の外（開閉のボタンやドラッグのハンドル）では出さない（lms-797 T9-7）。折りたたんで文言を
 * 隠しているときは、文言の大きさが 0 になるので出さない。クリックはこれまでどおり下の要素に届く。
 * popover="manual" にしているのは、ほかの画面のポップオーバー（popover="auto"）を閉じないようにするため。
 * 予定の位置は resources/css/app.css の .float-maintenance-countdown-schedule で決める。
 *
 * モバイル（タッチ操作）は対象外。Popover API に対応していないブラウザでは何もしない（popover 属性が無視され、予定は箱の中に
 * 表示されたままになる）。
 */

/**
 * 座標が要素の矩形の中にあるか（非表示で大きさが 0 の要素は、中に無いとみなす）
 *
 * @param {number} x
 * @param {number} y
 * @param {HTMLElement} element
 * @returns {boolean}
 */
const is_inside = (x, y, element) => {
    const rect = element.getBoundingClientRect()
    if (rect.width === 0 || rect.height === 0) return false
    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom
}

/**
 * 1つの予告の箱について、文言の上にあるマウスの座標に合わせて予定を開け閉めする処理をセットアップする
 *
 * @param {HTMLElement} notice
 * @returns {void}
 */
const setup_schedule_popover = (notice) => {
    const schedule = notice.querySelector('[data-maintenance-schedule]')
    const trigger = notice.querySelector('[data-maintenance-schedule-trigger]')
    if (schedule === null || trigger === null || typeof schedule.showPopover !== 'function') return

    /**
     * 予定を開く・閉じる（すでにその状態なら何もしない）
     *
     * @param {boolean} open
     * @returns {void}
     */
    const set_open = (open) => {
        if (schedule.matches(':popover-open') === open) return
        if (open) {
            schedule.showPopover()
        } else {
            schedule.hidePopover()
        }
    }

    document.addEventListener('mousemove', (event) => {
        set_open(is_inside(event.clientX, event.clientY, trigger))
    }, { passive: true })

    // マウスがウィンドウの外へ出たときは mousemove が来ないので、ここで閉じる
    document.addEventListener('mouseout', (event) => {
        if (event.relatedTarget === null) set_open(false)
    })
}

/**
 * 初期化
 *
 * @returns {void}
 */
const init_maintenance_schedule_popover = () => {
    const notices = document.querySelectorAll('[data-maintenance-notice]')
    notices.forEach((notice) => setup_schedule_popover(notice))
}

document.addEventListener('DOMContentLoaded', init_maintenance_schedule_popover)
